import NetworkAccountMainMenu from 'modules/network-accounts/menus/NetworkAccountMainMenu';
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PostbacksMainMenu from 'modules/PostbacksModule/menus/PostbacksMainMenu';
import ReportMainMenu from 'modules/ReportModule/menus/ReportMainMenu';
import SalesMainMenu from 'modules/sales/menus/SalesMainMenu';
import ReportingMainMenu from 'modules/ReportingModule/menus/ReportingMainMenu';
import CrmMainMenu from 'modules/CRMModule/menus/CrmMainMenu';
import RetentionMainMenu from 'modules/RetentionModule/menus/RetentionMainMenu';
import PnLMainMenu from 'modules/PnLReportModule/menu/PnLMainMenu';
import AcquisitionMainMenu from 'modules/AcquisitionModule/menu/AcquisitionMainMenu';
import ProductsMainMenu from 'modules/ProductsModule/menu/ProductsMainMenu';

const SecondaryMenu = ({ component }) => {
  return (
    <Switch>
      <Route path='/accounts' component={NetworkAccountMainMenu} />
      <Route path='/report' render={() => <ReportMainMenu dateRangeComponent={component} />} />
      <Route
        path='/postbacks'
        render={() => <PostbacksMainMenu dateRangeComponent={component} />}
      />
      <Route
        path='/retention'
        render={() => <RetentionMainMenu dateRangeComponent={component} />}
      />
      <Route path='/sales' render={() => <SalesMainMenu dateRangeComponent={component} />} />
      <Route
        path='/reporting'
        render={() => <ReportingMainMenu dateRangeComponent={component} />}
      />
      <Route path='/reporting/creative' />
      <Route path='/crm' render={() => <CrmMainMenu dateRangeComponent={component} />} />
      <Route path='/pnl-report' render={() => <PnLMainMenu dateRangeComponent={component} />} />
      <Route
        path='/acquisition'
        render={() => <AcquisitionMainMenu dateRangeComponent={component} />}
      />
      <Route path='/products' render={() => <ProductsMainMenu dateRangeComponent={component} />} />
    </Switch>
  );
};

export default SecondaryMenu;
